import React from 'react';
import PropTypes from 'prop-types';

import ErrorPanel from './errorPanel';

// eslint-disable-next-line react/prefer-stateless-function
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
      errorMessage: '',
    };
  }

  componentDidCatch(err) {
    this.setState({ errorMessage: err.message });
    this.setIsError(true);
  }

  setIsError = (isError) => {
    this.setState({ isError });
  }

  render() {
    if (this.state.isError) {
      return (
        <div className="error-boundary">
          <div className="background" />
          <ErrorPanel setIsError={this.setIsError} errorMessage={this.state.errorMessage} />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
